import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { ToasterService } from 'common/src/modules/ui-components/toaster';
import { OutgoingInvoiceModel } from '../../models';
import { InvoiceApiService } from '../../services/invoice-api.service';

@Component({
  selector: 'rnpl-force-complete-modal',
  templateUrl: './force-complete-modal.component.html',
})
export class ForceCompleteModalComponent implements OnDestroy {

  public completeBy: 'SKONTO_DEDUCTION'|'DISCOUNT_DEDUCTION'= 'SKONTO_DEDUCTION';

  @Input() invoice: OutgoingInvoiceModel;

  @Output() closeDialog: EventEmitter<boolean> = new  EventEmitter<boolean>();

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  readonly submitRequest$: BehaviorSubject<boolean> = new BehaviorSubject(null);

  constructor(
    private toasterService: ToasterService,
    private translateService: TranslateService,
    private invoiceApiService: InvoiceApiService,
  ) {
  }

  public submit(): void {
    if (this.submitRequest$.getValue()) { return; }
    this.submitRequest$.next(true);

    this.invoiceApiService.forceCompleteOutgoingInvoice(this.invoice.invoiceId, this.completeBy)
      .pipe(
        finalize(() => this.submitRequest$.next(false)),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.toasterService.notifySuccess('IIN.INVOICE_HAS_BEEN_PAID');
        this.close();
      }, (error: HttpErrorResponse) => {
        this.toasterService.notifyError(error.error.message || error.error.errors);
      });
  }

  public close(): void {
    this.closeDialog.emit();
  }

  get openAmount(): number {
    if (!this.invoice) { return null; }
    return +this.invoice.totals.openAmount;
  }

  get totalAmount(): number {
    if (!this.invoice) { return null; }
    return +this.invoice.totals.totalAmount;
  }

  // limit is 50€ or 1%
  get isOpenAmountMoreThanLimit(): boolean {
    if (!this.openAmount || !this.totalAmount) { return null; }
    return this.openAmount > 50
      ? true
      : (this.openAmount > (this.totalAmount / 100));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
